import React from 'react'
import { Grid, PanelGroup, Panel } from 'react-bootstrap'

import AuthenticationComponent from '../../AuthenticationComponent'
import ChangePassword from './components/ChangePassword'
import ChangeEmailSettings from './components/ChangeEmailSettings'

const UserSettingsContainer = (props) => {
  return (
    <div id="ManagerContainer">
      <AuthenticationComponent />
      <Grid>
        <PanelGroup
          accordion
          id="accordion-controlled"
          >
          <Panel eventKey="1">
            <Panel.Heading>
              <Panel.Title toggle>
                Change Password
              </Panel.Title>
            </Panel.Heading>
            <Panel.Body collapsible>
              <ChangePassword {...props} />
            </Panel.Body>
          </Panel>

          <Panel eventKey="2">
            <Panel.Heading>
              <Panel.Title toggle>
                Email Settings
              </Panel.Title>
            </Panel.Heading>
            <Panel.Body collapsible>
              <ChangeEmailSettings {...props}/>
            </Panel.Body>
          </Panel>
        </PanelGroup>
      </Grid>
    </div>
  )
}

export default UserSettingsContainer



// WEBPACK FOOTER //
// ./src/routes/user-settings/UserSettingsContainer.js